import $ from 'jquery';
import 'waypoints/lib/jquery.waypoints.min';
import 'waypoints/lib/shortcuts/sticky.min';
import 'waypoints/lib/shortcuts/inview.min';
import helpers from '../../js/helpers';

const { hash } = window.location;

// Refresh
Waypoint.refreshAll();
window.history.scrollRestoration = 'manual';

// On load
window.onload = function load() {
  Waypoint.refreshAll();

  if (hash) {
    helpers.goToSection($(hash), 0);
  }
};

$(() => {
  const elements = [];
  let winWidth = $(window).width();

  if (hash) {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1);
  }

  // Refresh all
  Waypoint.refreshAll();

  // Sticky
  const sticky = new Waypoint.Sticky({
    element: $('.services-menu-wrapper')[0],
    stuckClass: 'reached',
    offset() {
      return -this.element.clientHeight + 10;
    },
    handler(direction) {
      if (direction === 'down') {
        $('.float-options').addClass('reached');
      }

      if (direction === 'up') {
        $('.float-options').removeClass('reached');
      }
    },
  });

  // Inview
  const inview = new Waypoint.Inview({
    element: $('.services .info')[0],
    exited() {
      $('.services-menu a.active').removeClass('active');
    },
  });
  elements.push(sticky, inview);

  // Resize window
  $(window).resize((e) => {
    const $this = $(e.currentTarget);
    Waypoint.refreshAll();

    if ($this.width() !== winWidth) {
      $('.services-menu-wrapper').addClass('waiting');
      const ht = $('.services-menu-wrapper').outerHeight();
      winWidth = $this.width();

      setTimeout(() => {
        $('.services-menu-wrapper').removeClass('waiting');
        $('.sticky-wrapper').outerHeight(ht);
        Waypoint.refreshAll();
      });
    }
  });

  // Resize by header
  $('.header .navbar-toggler, .header .dropdown-toggle').on('click', () => {
    $('.services-menu-wrapper').addClass('waiting');
    const ht = $('.services-menu-wrapper').outerHeight();

    setTimeout(() => {
      $('.services-menu-wrapper').removeClass('waiting');
      $('.sticky-wrapper').outerHeight(ht);
      Waypoint.refreshAll();
    }, 300);
  });

  $('.header .services a').on('click', (e) => {
    const href = $(e.currentTarget).attr('href').split('#')[1];
    e.preventDefault();
    helpers.goToSection($(`#${href}`), 0);
    // window.location.hash = `#${href}`;

    setTimeout(() => {
      Waypoint.refreshAll();
    }, 300);
  });

  // $('.services-menu .action a').on('click', (e) => {
  //   const href = $(e.currentTarget).attr('data-section').split('#')[1];
  //   window.location.hash = `#${href}`;
  // });

  $('.services .section').waypoint({
    handler(direction) {
      const section = $(this.element).attr('id');

      if (direction === 'up') {
        $(`.services-menu a[data-section='#${section}']`).parent().nextAll('.action').find('a')
          .removeClass('active');
      }

      $(`.services-menu a[data-section='#${section}']`).addClass('active');
    },
    offset: -10,
  });

  $('.services .section').waypoint({
    handler(direction) {
      const section = $(this.element).attr('id');

      if (direction === 'down') {
        $(`.services-menu a[data-section='#${section}']`).parent().prevAll('.action').find('a')
          .removeClass('active');
      }

      $(`.services-menu a[data-section='#${section}']`).addClass('active');
    },
    offset: 10,
  });
});
